//引入路由
import router, { resetRouter } from "./router";
//网页加载显示插件
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import store from "@/store";
import storeRouter from "@/router/admin.js";

//引入Cookies文件中储存的token    具体token需要根据项目实际开发设置
//引入组件
const getToken = () => {
  const token = !store.getters.token
    ? localStorage.getItem("token")
    : store.getters.token;
  return token;
};
let userItem = localStorage.getItem("userInfo");
let userInfo =
  JSON.stringify(store.getters.userInfo) != "{}"
    ? store.getters.userInfo
    : userItem
    ? JSON.parse(userItem)
    : "";
//默认将加载显示插件属性设置为fales
NProgress.configure({ showSpinner: false });

//路由白名单  任何人都可以访问的路由路径  请根据项目自行添加
const whiteList = ["/login"];

//路由前置守卫
router.beforeEach((to, from, next) => {
  NProgress.start();
  if (getToken()) {
    console.log(userInfo);
    console.log(to.path != "/prepare" && userInfo && userInfo.auditStatus != 3);
    userInfo =
      JSON.stringify(store.getters.userInfo) != "{}"
        ? store.getters.userInfo
        : userItem
        ? JSON.parse(userItem)
        : "";
    if (to.path != "/prepare" && userInfo && userInfo.auditStatus != 3) {
      router.push("/prepare");
      NProgress.done();
      return;
    }
    if (to.path === "/login") {
      next();
      NProgress.done();
    } else {
      if (userInfo && userInfo.grade && userInfo.grade == 1 && !to.name) {
        resetRouter;
        storeRouter.forEach((item) => {
          router.addRoute(item);
        });
        next(to.path);
      } else {
        next();
      }

      NProgress.done();
    }
  } else {
    // 没有token
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next();
      NProgress.done();
    } else {
      next(`/login?redirect=${to.fullPath}`); // 否则全部重定向到登录页
      NProgress.done();
    }
  }
});
